import { takeLatest } from 'redux-saga/effects';

function* handleFileUpload(action: any) {
  // Upload logic is handled directly in the component with axios
  // This saga can be used for additional side effects if needed
}

export default function* uploadSaga() {
  yield takeLatest('upload/uploadFileRequest', handleFileUpload);
}